import script from "./ArtistVisibilityManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistVisibilityManager.vue?vue&type=script&setup=true&lang=js"

import "./ArtistVisibilityManager.vue?vue&type=style&index=0&id=00651c8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00651c8f"]])

export default __exports__